import { PhoneOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import TriggerAiCallContent from 'automations/components/Nodes/TriggerAiCallContent';
import { type TriggerAiCallNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useTriggerAiCall(node: NodeProps<TriggerAiCallNodeType>): ActionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.TriggerAiCallActionNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <TriggerAiCallContent node={node} />, [node]);
  return {
    icon: PhoneOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
